// src/features/shopfloor/store/shopfloorStore.ts
// ADR-102. Local UI-only state (selected work center / shift for the
// shopfloor screens). No server data lives here — that stays in
// TanStack Query (see ../api.ts) per project convention.

import { create } from "zustand";

interface ShopfloorUIState {
  selectedWorkCenterId: string | null;
  selectedShiftId: string | null;
  setSelectedWorkCenterId: (id: string | null) => void;
  setSelectedShiftId: (id: string | null) => void;
  reset: () => void;
}

export const useShopfloorStore = create<ShopfloorUIState>((set) => ({
  selectedWorkCenterId: null,
  selectedShiftId: null,
  setSelectedWorkCenterId: (id) => set({ selectedWorkCenterId: id }),
  setSelectedShiftId: (id) => set({ selectedShiftId: id }),
  reset: () => set({ selectedWorkCenterId: null, selectedShiftId: null }),
}));
